import React from "react";

const TeamIcon = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={size}
      height={size}
      x="0"
      y="0"
      viewBox="0 0 490.667 490.667"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <g>
              <path
                d="M244.587,241.557c32.128-18.389,54.08-52.629,54.08-92.224c0-58.816-47.851-106.667-106.667-106.667     S85.333,90.517,85.333,149.333c0,39.595,21.952,73.835,54.08,92.224C59.051,262.656,0,330.603,0,411.136v26.197     C0,443.221,4.779,448,10.667,448s10.667-4.779,10.667-10.667v-26.197C21.333,325.611,97.899,256,192,256     s170.667,69.611,170.667,155.136v26.197c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667v-26.197     C384,330.603,324.949,262.635,244.587,241.557z M106.667,149.333C106.667,102.272,144.939,64,192,64s85.333,38.272,85.333,85.333     c0,47.061-38.272,85.333-85.333,85.333S106.667,196.395,106.667,149.333z"
                fill="#ffffff"
                data-original="#000000"
              />
              <path
                d="M388.224,241.835c23.125-15.296,38.443-41.451,38.443-71.168c0-47.061-38.272-85.333-85.333-85.333     c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667c35.285,0,64,28.715,64,64s-28.715,64-64,64     c-5.888,0-10.667,4.779-10.667,10.667S335.445,256,341.333,256c70.592,0,128,53.056,128,118.293v20.373     c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667v-20.373     C490.667,312.64,447.659,260.267,388.224,241.835z"
                fill="#ffffff"
                data-original="#000000"
              />
            </g>
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
      </g>
    </svg>
  );
};

export default TeamIcon;
